import { render, staticRenderFns } from "./NotificationsOption.vue?vue&type=template&id=d0e96aa4&"
import script from "./NotificationsOption.vue?vue&type=script&lang=js&"
export * from "./NotificationsOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports